<template>
  <div>
    <el-dialog title="请先绑定通联账户" :visible.sync="checkDialog" width="550px">
      <el-dialog width="400px" title="预留手机号验证" :visible.sync="codeFlag" append-to-body>
        <el-form class="bing-from-box" :model="cardForm" :rules="cardRules" ref="cardForm" label-position="left" label-width="100px">
          <el-form-item label="预留手机号">
            <p>{{ cardForm.phone }}</p>
          </el-form-item>
          <el-form-item label="验证码">
            <el-input  v-model="cardForm.smCode" type="number" placeholder="请输入验证码"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="codeFlag = false">取 消</el-button>
          <el-button type="success" @click="bindSmBtn">确 定</el-button>
        </div>
      </el-dialog>
      <!-- <el-steps align-center :space="200" :active="active" finish-status="success">
        <el-step title="绑定手机号"></el-step>
        <el-step title="实名认证"></el-step>
        <el-step title="绑定银行卡"></el-step>
        <el-step title="签约"></el-step>
      </el-steps> -->
      <div class="form-container">
        <template v-if="active === 0 || active === 1">
          <el-form class="bing-from-box" :model="bindFrom" :rules="rules" ref="bindFrom" label-position="left" label-width="130px">
            <el-form-item label="手机号" prop="phone">
              <el-input  v-model="bindFrom.phone" type="number" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="verificationCode">
              <div class="code-box">
                <el-input  v-model="bindFrom.verificationCode" autocomplete="off" type="number"></el-input>
                <el-button type="text" :disabled="timer ? true : false" placeholder="请输入验证码" @click="sendCodeBtn">
                  {{ sendText }}
                </el-button>
              </div>
            </el-form-item>
          </el-form>
        </template>
        <!-- <template v-if="active === 1">
          <el-form class="bing-from-box" :model="towForm" :rules="towRules" ref="towForm" label-position="left" label-width="130px">
            <el-form-item label="姓名" prop="name">
              <el-input  v-model="towForm.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="identityNo">
              <el-input  v-model="towForm.identityNo" placeholder="请输入身份证号"></el-input>
            </el-form-item>
            <el-form-item label="证件开始有效期" prop="identityBeginDate">
              <el-date-picker v-model="towForm.identityBeginDate" type="date" placeholder="请选择证件开始有效期" style="width: 100%"> </el-date-picker>
            </el-form-item>
            <el-form-item label="证件结束有效期" prop="identityEndDate">
              <el-date-picker v-model="towForm.identityEndDate" type="date" placeholder="请选择证件结束有效期" style="width: 100%"> </el-date-picker>
            </el-form-item>
            <el-form-item label="所在地" prop="address">
              <el-input  v-model="towForm.address" placeholder="住所地或者工作单位地址:不少于 10 个中文汉字"></el-input>
            </el-form-item>
            <el-form-item label="职业" prop="professionNo">
              <el-select v-model="towForm.professionNo" filterable style="width: 100%">
                <el-option :value="10000" label="党的机关、国家机关、群众团体和社会组织、企事业单位负责人"></el-option>
                <el-option :value="20000" label="专业技术人员"></el-option>
                <el-option :value="20700" label="法律、社会和宗教专业人员"></el-option>
                <el-option :value="20800" label="教学人员"></el-option>
                <el-option :value="30000" label="办事人员和有关人员"></el-option>
                <el-option :value="40000" label="社会生产服务和生活服务人员"></el-option>
                <el-option :value="40100" label="批发与零售服务人员"></el-option>
                <el-option :value="40300" label="住宿和餐饮服务人员"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </template> -->
        <!-- <template v-if="active === 2">
          <el-form class="bing-from-box" :model="cardForm" :rules="cardRules" ref="cardForm" label-position="left" label-width="130px">
            <el-form-item label="姓名">
              <p>{{ userData.name }}</p>
            </el-form-item>
            <el-form-item label="身份证号">
              <p>{{ userData.identityNo }}</p>
            </el-form-item>
            <el-form-item label="银行卡号" prop="card_no">
              <el-input  v-model="cardForm.card_no" type="number" placeholder="请输入银行卡号"></el-input>
            </el-form-item>
            <el-form-item label="预留手机号" prop="phone">
              <el-input  v-model="cardForm.phone" type="number" placeholder="请输入银行预留手机号"></el-input>
            </el-form-item>
          </el-form>
        </template> -->
        <!-- <template v-if="active === 3">
          <div class="sign-box">
            <img src="https://webwlx.oss-cn-beijing.aliyuncs.com/public/undraw_Terms_re_6ak4.png" alt="" />
          </div>
        </template> -->
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkDialog = false">取 消</el-button>
        <el-button v-if="active !== 3" type="primary" @click="subBtn">确 定</el-button>
        <el-button v-else type="success" @click="subBtn">签 约</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue';
import * as API_userMember from '@/api/userMember';
import { Step, Steps, Dialog, Form, FormItem, Input, Button } from 'element-ui';
import { RegExp } from '~/ui-utils';
Vue.use(Input)
  .use(Dialog)
  .use(Form)
  .use(FormItem)
  .use(Button)
  .use(Steps)
  .use(Step);
import dayjs from 'dayjs';
import { signContractStatus } from '@/api/userMember';

export default {
  name: 'checkUser.vue',
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!RegExp.mobile.test(value)) {
         callback(new Error('请输入正确的手机号'))
         
      } else {
        callback()
      }
      
    }
    return {
      checkDialog: false,
      bindFrom: {
        phone: '',
        verificationCode: '',
      },
      towForm: {
        name: '',
        identityNo: '',
        identityBeginDate: '', //证件开始有效期
        identityEndDate: '', //证件结束有效期
        address: '',
        professionNo: '',
      },
      cardForm: {
        card_no: '',
        phone: '',
        smCode: '',
      },
      rules: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'change' },
        { validator: validatePhone, trigger: 'blur' }],
        verificationCode: [{ required: true, message: '请输入验证码', trigger: 'change' }],
      },
      towRules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'change' }],
        identityNo: [{ required: true, message: '请输入身份证号', trigger: 'change' }],
        identityBeginDate: [{ required: true, message: '请选择证件有效期', trigger: 'change' }],
        identityEndDate: [{ required: true, message: '请选择证件有效期', trigger: 'change' }],
      },
      cardRules: {
        card_no: [{ required: true, message: '请输入银行卡号', trigger: 'change' }],
        phone: [{ required: true, message: '请输入预留手机号', trigger: 'change' }],
      },
      sendText: '发送验证码',
      timer: null,
      count: null,
      active: '',
      codeFlag: false,
      singUrl: '',
      userData: {
        identityNo: '',
        identityType: '',
        bizPhone: '',
        name: '',
      },
    };
  },
  mounted() {
    this.checkUser();
  },
  methods: {
    sendCodeBtn() {
      this.$refs.bindFrom.validateField('phone', valid => {
        if (this.bindFrom.phone && RegExp.mobile.test(this.bindFrom.phone)) {
          API_userMember.openUserSendPhone({ phone: this.bindFrom.phone }).then(response => {
            if (response) {
              if (response.status_flag == 'true') {
                return;
              }
              this.$message.success('发送成功，请注意查收');
              const TIME_COUNT = 60;
              if (!this.timer) {
                this.count = TIME_COUNT;
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--;
                    this.sendText = `${this.count}s 后，重新发送`;
                  } else {
                    this.sendText = '发送验证码';
                    clearInterval(this.timer);
                    this.timer = null;
                    this.count = null;
                  }
                }, 1000);
              }
            }
          });
        }
      });
    },
    bindSmBtn() {
      if (!this.cardForm.smCode) {
        this.$message.error('请输入验证码');
        return false;
      }
      API_userMember.bindBankCard({
        verification_code: this.cardForm.smCode,
        trance_num: this.userData.trance_num, //流水号
        phone: this.cardForm.phone,
      }).then(response => {
        if (response) {
          this.$message.success('绑定成功');
          this.codeFlag = false;
          this.checkUser();
        }
      });
    },
    async subBtn() {
      const { active, towForm, bindFrom, cardForm, userData } = this;
      let fromName = 'bindFrom';
      if (active === 1) {
        // fromName = 'towForm';
      } else if (active === 2) {
        fromName = 'cardForm';
      }
      if (this.active === 3) {
        //  去签约'
        await this.checkUser();
        window.open(this.singUrl);
      }
      this.$refs[fromName].validate(async valid => {
        if (valid) {
          if (active === 0 || active === 1) {
            await API_userMember.openUser(bindFrom).then(response => {
              if (response==true||response=='true') {
                this.$message.success('绑定成功');
                this.checkUser()
              }
            });
          } else if (active === 8) {
            let { profession_no, name, address, identityBeginDate, identityEndDate, identityNo } = towForm;
            await API_userMember.setRealName({
              name,
              auth: true,
              identity_type: 1,
              address,
              identity_begin_date: dayjs(identityBeginDate).format('YYYY-MM-DD'),
              identity_end_date: dayjs(identityEndDate).format('YYYY-MM-DD'),
              identity_no: identityNo,
              profession_no,
            }).then(response => {
              if (response) {
                this.$message.success('实名认证成功');
              }
            });
          } else if (active === 2) {
            await API_userMember.applyBindBankCard({
              card_check: 7, //绑卡方式
              card_no: cardForm.card_no,
              cvv2: '',
              identity_no: userData.identityNo,
              identity_type: 0,
              name: userData.name,
              phone: cardForm.phone,
              union_bank: '',
              validate: '',
            }).then(response => {
              if (response.code === '200') {
                Object.assign(this.userData, {
                  trance_num: response.trance_num,
                  biz_user_id: response.biz_user_id,
                });
                this.codeFlag = true;
                return false;
                //  短信验证
              }
            });
          }
          if (this.active !== 2) {
            this.checkUser();
          }
        }
      });
    },
    // 检测是否绑定了通联
    checkUser() {
      API_userMember.isCheck().then(response => {
        // 0 表示未开始1 绑定了手机号 2 身份证绑定好了。3 银行卡添加好了 4 签约
        //memberType  为空 或者  0 没有创建   2正在创建通联企业   3已经创建过 通联个人账号
        if(response.memberType && response.memberType == 2){
          console.log(window.location)
          if(window.location.pathname.indexOf('account-balance') > -1){
             return this.$message('该账号为商家账号，无法充值余额');
          }else {
            return this.$message('该账号为商家账号，无法购买商品');
          }
        }
        if (response.steps === 4) {
          this.$emit('checkUserSuccess', true);
          this.checkDialog = false
        } else {
          Object.assign(this.userData, response);
          this.active = Number(response.steps);
          if (this.active !== 3) {
            this.checkDialog = true;
          }
          if (response.steps === 2) {
            this.cardForm.phone = response.bizPhone;
          } else if (response.steps === 3) {
            // 判断有没有签约成功的参数 ，如果有返回给后端，如果没有，返回给前端
            let data = this.$route.query.bizContent ? JSON.parse(this.$route.query.bizContent) : new Object();
            if (data.result === 'OK') {
              // alert('签约成功') 通知后端
              API_userMember.signContractStatus({ status: 1 }).then(res => {
                if (res) {
                  this.$message.success('签约成功');
                  this.$emit('checkUserSuccess', true);
                }
              });
              return false;
            } else {
              // 获取签约地址
              API_userMember.signContract({
                jumpPageType: 1,
                jumpUrl: location.href,
                noContractUrl: location.href,
              }).then(res => {
                this.singUrl = res; // 签约地址
                this.checkDialog = true;
              });
            }
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.sign-box {
  img {
    display: block;
    width: 80%;
    margin: 0 auto;
  }
}

.form-container {
  margin-top: 30px;
}

.code-box {
  display: flex;
  justify-content: space-between;
  align-items: center;

  /deep/ .el-input {
    flex: 1;
  }

  .el-button {
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/checkUser.vue